var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpecimensOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5013 8V4M15.168 4H17.8346",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5026 24L16.5026 28M17.8359 28L15.1693 28",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1574 10.3435L24.9858 7.51507M24.043 6.57227L25.9286 8.45788",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8426 21.6575L8.01422 24.4859M8.95703 25.4287L7.07141 23.5431",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.0003L28.5 16.0003M28.5 14.667L28.5 17.3337",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.0007L4.5 16.0007M4.5 17.334L4.5 14.6673",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1585 21.6564L24.9869 24.4848M25.9297 23.542L24.0441 25.4276",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8455 10.3426L8.01703 7.51422M7.07422 8.45703L8.95984 6.57141",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 8,
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1667,
    cy: 14.6667,
    r: 2.66667,
    fill: "#EE7203"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1654,
    cy: 18.6663,
    r: 1.33333,
    fill: "#EE7203"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpecimensOrange);
export default __webpack_public_path__ + "static/media/icon-specimens-orange.4d8cfed3690b3f4d1c33e64ab5ca1539.svg";
export { ForwardRef as ReactComponent };